import { getBydomainName } from "@/api/autoweb";
export function setHeaderIcon(url) {
  var link = document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
}
const currentOrigin = process.env.NODE_ENV === 'development' ? 'http://medpro.ydmob.com' : location.origin

export async function getOriginConfig() {
  const res = await getBydomainName({
    domainName: currentOrigin,
  });
  return res
}
